module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"this_is_preview":"Booking Form Preview","please_select_at_least_1_item":"Please select at least 1 item"},"zh":{"this_is_preview":"預覽 預約問卷","please_select_at_least_1_item":"請至少選購一項商品哦"}}')
  delete Component.options._Ctor
}
